import React from "react";
import Sdata from "./Sdata";
import Card from "./Cards";

const Moviesa = ()=>{
    return(
        <Card
              key={Sdata[1].id}
              imgsrc={Sdata[1].imgsrc}
              title={Sdata[1].title}
              text={Sdata[1].text}
              link={Sdata[1].link} />
    )
}
export default Moviesa;